import React from 'react'
import { PrivacyPolicy } from '../../menu/footer/PrivacyPolicy'

/**
 * `/privacy` — the privacy policy outside the app menu, so it opens without an
 * account (linked from the event sign-up, where the person has none yet).
 */
export const PublicPrivacyPolicy: React.FC = () => <PrivacyPolicy />
